<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Usuarios",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
            ],
            usuarios:[],
            datos_editar:{
                sede:'',
                tipo:'',
                rut:'',
                nombre:'',
                correo:'',
                telefono:'',
            },
            habilitar_boton: false,  
            editing: false,
            originalUser:'',
            emailError:'',
            phoneerror:'',
            ruterror:'',
            sedes:['Viña del Mar', 'Santiago', 'Concepción'],
            cargos:['Coordinador Vigente','Coordinador de reemplazo','Supervisor','Supervisor General'],
            isLoading: false,
        };
    },
    computed: {
    
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        ver_mas(usuario){
            this.editing = false;
            if (usuario.boton=='Ver más') {
                usuario.boton='Ver menos'
            }else if(usuario.boton=='Ver menos'){
                usuario.boton='Ver más'
            }
        },
        actualizar(){
            this.isLoading = true;
            axios.get('/api/actualizar_usuarios_colegios').then(res=>{
                if (res.data.estado) {
                    this.isLoading = false;
                    this.msg('sucess',res.data.mensaje)
                }else{
                    this.isLoading = false;
                    this.msg('error',res.data.mensaje)
                }
            });
        }
    },
    created(){
        axios.get('/api/get_usuarios_colegios').then(res=>{
            this.usuarios=res.data.usuarios.filter((item) => 
                item.rol=='Coordinador' && item.id!='20'
            );
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message v-if="isLoading" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="mt-3 float-right">
                            <b-button variant="primary" @click="actualizar">
                                <i class="bx bx-revision"></i> Actualizar
                            </b-button>
                        </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 20px;">#</th>
                                        <th style="width: 400px;">Nombre</th>
                                        <th style="width: 150px;">Rut</th>
                                        <th style="width: 200px;">Cantidad Asignados</th>
                                        <th class="text-right">Detalle</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="table-responsive" v-for="(usuario,index) in usuarios" :key="index">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th style="width: 20px;">{{ index+1 }}</th>
                                        <td style="width: 400px;">{{usuario.name}}</td>
                                        <td style="width: 150px;">{{usuario.rut}}</td>
                                        <td style="width: 200px;" class="text-center">{{usuario.colegios_asignados.length}}</td>
                                        <td class="text-right">
                                            <b-button v-b-toggle="'accordion-'+usuario.id" variant="secondary" @click="ver_mas(usuario)">
                                                {{usuario.boton}}
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-collapse :id="'accordion-'+usuario.id" accordion="my-accordion" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="card mt-3 shadow-sm border-light">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <p class="font-size-16"><strong>Nombre:</strong> {{ usuario.name }}</p>
                                                                <p class="font-size-16"><strong>Sede:</strong> {{ usuario.sede }}</p>
                                                                <p class="font-size-16"><strong>Correo Electrónico:</strong> {{ usuario.email }}</p>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="font-size-16"><strong>Rut:</strong> {{ usuario.rut }}</p>
                                                                <p class="font-size-16"><strong>Tipo de Usuario:</strong> {{ usuario.cargo }}</p>
                                                                <p class="font-size-16"><strong>Teléfono:</strong> {{ usuario.telefono }}</p>
                                                            </div>
                                                            <div class="offset-md-2 col-md-8">
                                                                <h5>Colegios Asignados</h5>
                                                                <div class="table-responsive">
                                                                    <table class="table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>#</th>
                                                                                <th>Nombre</th>
                                                                                <th>RBD</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(colegio,index) in usuario.colegios_asignados" :key="index">
                                                                                <td>{{ index+1 }}</td>
                                                                                <td>{{ colegio.nombre }}</td>
                                                                                <td>{{ colegio.rbd }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>